module.exports = __webpack_public_path__ + "static/infinite-living-mobile-f9dd009bcafe8fe98a32de82ae46d478.jpg";